import type { CSSProperties } from 'react';

interface ToggleProps {
  checked?: boolean;
  label?: string;
  className?: string;
  style?: CSSProperties;
}

export function ToggleView({ checked = false, label, className, style }: ToggleProps) {
  return (
    <label
      className={`flex items-center gap-2 text-sm text-zinc-700 dark:text-zinc-300${className ? ` ${className}` : ''}`}
      style={style}
    >
      <div
        className={`relative h-5 w-9 rounded-full transition-colors ${checked ? 'bg-blue-600' : 'bg-zinc-300 dark:bg-zinc-600'}`}
      >
        <div
          className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-transform ${checked ? 'translate-x-4' : 'translate-x-0.5'}`}
        />
      </div>
      {label && <span>{label}</span>}
    </label>
  );
}
